import { atom } from 'jotai';
import { $PageLevelTraffic } from 'shared/atoms';
import { EPageType } from 'shared/models';
import { pendingQueue } from '~/utils/pending-queue';

export const $CurrentHashtagId = atom((get) => {
  const traffic = get($PageLevelTraffic);
  const { pageType } = traffic;

  if (pageType !== EPageType.hashtag) {
    // eslint-disable-next-line @typescript-eslint/no-throw-literal
    throw new Promise((resolve) => pendingQueue.push(resolve));
  }

  return traffic.hashtagId;
});
